import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  Button,
  CardContent,
  IconButton,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { styled } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { showToast } from "../../helpers/ToastifyHelper";
 
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontWeight: "bold",
  border: "3px solid lightgrey", // Tüm hücrelere kenarlık ekle
}));
 
const DocumentTable = ({ rows, onUpdateDocuments, paddingX = "" }: any) => {
  if (!rows || rows.length === 0) return null;
 
  const handleFileUpload = (e: any, id: number) => {
    const file = e.target.files[0];
 
    if (file) {
      // Dosya türü kontrolü
       const allowedTypes = [
        "application/pdf",
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/webp",
      ];
 
      const fileExtension = file.name.toLowerCase().split(".").pop();
      const allowedExtensions = [
        "pdf",
        "jpg",
        "jpeg",
        "png",
        "webp",
      ];
 
      const typeAllowed = allowedTypes.includes(file.type);
      const extAllowed = allowedExtensions.includes(fileExtension);
      if (!typeAllowed || !extAllowed) {
        showToast("Sadece PDF ve fotoğraf dosyaları yüklenebilir!", "error");
        return;
      }

      // Dosya boyutu kontrolü (maksimum 10 MB)
      const MAX_FILE_SIZE_MB = 10;
      const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
      if (file.size > MAX_FILE_SIZE_BYTES) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        showToast(`Dosya boyutu çok büyük (${fileSizeMB} MB). Maksimum ${MAX_FILE_SIZE_MB} MB olabilir.`, "error");
        return;
      }
       
      const updatedDocuments = rows.map((row: any) =>
        row.id === id
          ? { ...row, fileName: file.name, file: file }
          : row
      );
 
      onUpdateDocuments(updatedDocuments);
    }
  };
 
  const handleFileRemove = (id: number) => {
    const updatedDocuments = rows.map((row: any) =>
      row.id === id ? { ...row, fileName: "", file: null } : row
    );
    onUpdateDocuments(updatedDocuments);
  };
 
  return (
    <CardContent className={paddingX}>
      <div style={{ overflow: "auto" }} className="row mx-auto">
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Belge Adı</StyledTableCell>
              <StyledTableCell align="right">Dosya Adı</StyledTableCell>
              <StyledTableCell align="right">Zorunluluk Durumu</StyledTableCell>
              <StyledTableCell align="right">Yükle/Sil</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row: any) => (
              <TableRow key={row.id}>
                <StyledTableCell component="th" scope="row">
                  {row.documentName}
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Button
                    variant="outlined"
                    component="span"
                    startIcon={
                      row.fileName ? <CheckCircleIcon color="success" /> : null
                    }
                  >
                    {row.fileName || "Yükleme Bekleniyor"}
                  </Button>
                </StyledTableCell>
                <StyledTableCell align="right">
                  <Checkbox
                    checked={row.isRequired}
                    onChange={(e) => {
                      const updated = rows.map((r: any) => r.id === row.id ? { ...r, isRequired: e.target.checked } : r);
                      onUpdateDocuments(updated);
                    }}
                    style={{ pointerEvents: "none" }}
                    inputProps={{ "aria-label": `belge-${row.id}-zorunlu` }}
                  />
 
                </StyledTableCell>
                <StyledTableCell align="right">
                  <input
                    key={`file-${row.id}-${row.fileName}`}
                    type="file"
                    id={`file-upload-${row.id}`}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileUpload(e, row.id)}
                  />
                  <label htmlFor={`file-upload-${row.id}`}>
                    <IconButton component="span">
                      <UploadFileIcon />
                    </IconButton>
                  </label>
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleFileRemove(row.id)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </CardContent>
  );
};
 
export default DocumentTable;
 